<style>
@import '../../assets/css/register.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <form id="newRegisterForm" @submit.prevent="newRegister" :submit="newRegister">
                    <b-card :header="$t('admin.table_account_info')" header-tag="header">
                        <b-row>
                            <b-col cols='12' lg="6">
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_user_id')}} <span class="text-red">(*)</span></template>
                                    <b-form-input name="username"></b-form-input>
                                </b-form-group>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_password')}} <span class="text-red">(*)</span></template>
                                    <b-form-input type="password" name="password"></b-form-input>
                                </b-form-group>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_password_confirm')}} <span class="text-red">(*)</span></template>
                                    <b-form-input type="password" name="confirm_password"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols='12' lg="6">
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_sponsor')}} <span class="text-red">(*)</span></template>
                                    <b-input-group>
                                        <b-form-input name="sponsor" v-model="sponsor"></b-form-input>
                                        <b-input-group-append>
                                            <b-button variant="primary" @click="checkSponsor()">{{$t('button.check')}}</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                                <!-- <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_wechat_id')}} <span class="text-red">(*)</span></template>
                                    <b-form-input name="wechat_id"></b-form-input>
                                </b-form-group> -->
                                <b-form-group label-cols="12" label-cols-lg="4" v-if="permissionList.includes(permission.account_job)">
                                    <template slot="label">{{$t('profile.table_account_job')}}</template>
                                    <b-form-select name="account_job">
                                        <option value="member">{{$t('general.member')}}</option>
                                        <option value="admin">{{$t('general.admin')}}</option>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card>

                    <!-- <b-card :header="$t('admin.table_package_info')" header-tag="header" class="mt-5">
                        <b-row>
                            <b-col cols='12' lg="6">
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_account_type')}} <span class="text-red">(*)</span></template>
                                    <b-form-select name="at_id" v-model="ajaxDefault.account_type">
                                        <option v-for="(type,index) in ajaxTable.account_list" :key="index" :value='type.id'>{{type.name}}</option>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col cols='12' lg="6">
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_select_package')}} <span class="text-red">(*)</span></template>
                                    <b-form-select name="package_id" v-model="ajaxDefault.package">
                                        <option v-for="(list,index) in ajaxTable.package_list" :key="index" :value='list.id'>{{list.name}}</option>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card> -->

                    <!-- <b-card :header="$t('admin.table_personal_info')" header-tag="header" class="mt-5">
                        <b-row>
                            <b-col cols='12' lg="6">
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_name')}} <span class="text-red">(*)</span></template>
                                    <b-form-input name="my_name"></b-form-input>
                                </b-form-group>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_email')}} <span class="text-red">(*)</span></template>
                                    <b-form-input name="my_email"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols='12' lg="6">
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_handphone')}} <span class="text-red">(*)</span></template>
                                    <b-form-input name="handphone"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card> -->

                    <b-card :header="$t('admin.table_agreement')" header-tag="header" class="mt-5">
                        <b-row>
                            <b-col cols='12' lg="6">
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_my_security')}} <span class="text-red">(*)</span></template>
                                    <b-form-input type="password" name="my_security"></b-form-input>
                                </b-form-group>
                                <!-- <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_payment_method')}} <span class="text-red">(*)</span></template>
                                    <b-form-select name="payment_id">
                                        <option v-for="(payment,index) in ajaxTable.payment_list" :key="index" :value='payment.code'>{{payment.name}}</option>
                                    </b-form-select>
                                </b-form-group> -->
                            </b-col>
                            <b-col cols='12' lg="6">
                                <b-row style="line-height:35px">
                                    <b-col cols='3'>
                                        <b-form-checkbox name="status" size="lg" value="1" unchecked-value="0" switch></b-form-checkbox>                                    
                                    </b-col>
                                    <b-col cols='9'>
                                        <span>{{$t('admin.table_agreement_msg')}}
                                            <b-button variant="primary" size="lg">
                                                <font-awesome-icon :icon="['fas', 'info-circle']"></font-awesome-icon> {{$t('button.user_agreement')}}
                                            </b-button>
                                        </span>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="6" class="mx-auto mt-3">
                                <b-button variant="primary" type="submit" block >{{$t('button.submit')}} <font-awesome-icon :icon="['fas', 'check']"></font-awesome-icon></b-button>
                            </b-col>
                        </b-row>
                    </b-card>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import {getNewRegister,newRegister,checkSponsor} from '@/system/model/register';
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{
            ajaxLoad: false,
            ajaxTable: [],
            ajaxDefault: {account_type:'',package:''},
            sponsor:'',
            permission:{
                submit:'27A94E',
                account_job:'A28902'
            },
            permissionList:[]
        }   
    },methods:{
        initialize(){
            var self = this;
            var result = getNewRegister();
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data;
                    // self.ajaxDefault.account_type = value.data.account_list[0].id;
                    // self.ajaxDefault.package = value.data.package_list[0].id;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },checkSponsor(){
            var self = this;
            var result = checkSponsor(this.sponsor);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.$swal.fire({
                        type: 'success',
                        text: self.$t(value.returnMsg)
                    });
                }else{
                    var text = "";
                    if(Array.isArray(value.returnMsg)){
                        value.returnMsg.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                    }else{
                        text = self.$t(value.returnMsg);
                    }

                    self.$swal.fire({
                        type: 'error',
                        html: text
                    });
                }
            });		
        },newRegister(){
            // if(this.permissionList.includes(this.permission.submit)){
                var self = this;
                var form = document.getElementById('newRegisterForm');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                var result = newRegister(formData);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg,{member:value.member}),
                            onClose: () => {
                                if(value.refresh == 0){
                                    self.initialize();
                                }else{
                                    location.reload();
                                }
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                if(value.refresh == 0){
                                    self.initialize();
                                }else{
                                    location.reload();
                                }
                            }
                        });
                    }
                });
            // }
        }
    },created(){
        this.initialize();
    }
}
</script>

